<ng-container *ngIf="routerURL$ | async"></ng-container>
<ion-grid
	[class.jobfair]="class === 'jobfair'"
	[class.people]="class === 'people'"
	[class.company]="class === 'company'"
	[class.serverless]="class === 'serverless'"
	[class.courses]="class === 'courses'"
	[class.profile]="class === 'profile'"
	[class.hubble]="class === 'hubble'"
	class="common"
>
	<ion-row class="flex justify-start font-sans max-w-1336">
		<ion-col size-xl="8" size-lg="8" size-md="9" class="left-col flex-center">
			<div
				class="ion-activatable ripple-parent"
				(click)="menuUpdate('jobfair')"
				*ngIf="pagesService.getPermissionByName('jobfair') | async"
				[class.active]="class === 'jobfair'"
			>
				<div class="background"></div>
				<div class="flex-center menu">
					<ion-icon name="book-outline"></ion-icon>
					<span class="Body_M">Jobfair</span>
				</div>

				<ion-ripple-effect></ion-ripple-effect>
			</div>
			<div
				class="ion-activatable ripple-parent"
				(click)="menuUpdate('courses')"
				[class.active]="class === 'courses'"
				*ngIf="pagesService.getPermissionByName('courses') | async"
			>
				<div class="background"></div>
				<div class="flex-center menu">
					<ion-icon name="people-outline"></ion-icon>
					<span class="Body_M">Courses</span>
				</div>
				<ion-ripple-effect></ion-ripple-effect>
			</div>
			<div
				class="ion-activatable ripple-parent"
				(click)="menuUpdate('company')"
				[class.active]="class === 'company'"
				*ngIf="pagesService.getPermissionByName('company') | async"
			>
				<div class="background"></div>
				<div class="flex-center menu">
					<ion-icon name="briefcase-outline"></ion-icon>
					<span class="Body_M">Company</span>
				</div>
				<ion-ripple-effect></ion-ripple-effect>
			</div>
			<div
				class="ion-activatable ripple-parent"
				(click)="menuUpdate('profile')"
				*ngIf="pagesService.getPermissionByName('profile') | async"
				[class.active]="class === 'profile'"
			>
				<div class="background"></div>
				<div class="flex-center menu">
					<ion-icon name="calendar-clear-outline"></ion-icon>
					<span class="Body_M">Profile</span>
				</div>
				<ion-ripple-effect></ion-ripple-effect>
			</div>
			<div
				class="ion-activatable ripple-parent"
				(click)="menuUpdate('serverless')"
				*ngIf="pagesService.getPermissionByName('serverless') | async"
				[class.active]="class === 'serverless'"
			>
				<div class="background"></div>
				<div class="flex-center menu">
					<ion-icon name="calendar-clear-outline"></ion-icon>
					<span class="Body_M">Serverless</span>
				</div>
				<ion-ripple-effect></ion-ripple-effect>
			</div>
			<div
				class="ion-activatable ripple-parent"
				(click)="menuUpdate('hubble')"
				*ngIf="pagesService.getPermissionByName('hubble') | async"
				[class.active]="class === 'hubble'"
			>
				<div class="background"></div>
				<div class="flex-center menu">
					<ion-icon name="calendar-clear-outline"></ion-icon>
					<span class="Body_M">Community</span>
				</div>
				<ion-ripple-effect></ion-ripple-effect>
			</div>
		</ion-col>
		<ion-col size-xl="4" size-lg="4" size-md="3" class="right-col">
			<div class="ion-row">
				<div
					(click)="presentLogoutModal($event)"
					*ngIf="profile$ | async as profile"
					class="h-40"
				>
					<img
						default="/assets/default-img/profile.jpg"
						alt="title"
						[src]="profile.data.multimedia"
						class="profile-icon rounded-full"
					/>
				</div>
			</div>
		</ion-col>
	</ion-row>
</ion-grid>
